import GET_COUNTRIES from "./get-countries.graphql";

const getCountriesProvider = ({ gqlClient }) => () =>
	gqlClient(GET_COUNTRIES).then(result => result.getCountries);

export default getCountriesProvider;
